/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function AddSmall(props: CustomSvgIcon) {
    const {
        className,
        id,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>Add</title>
                <g
                    data-name='Layer 2'
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        fill={iconColor || '#202020'}
                        id='Layer_1-2'
                    >
                        <path d='M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM19.25,13.25h-6v6h-2.5v-6h-6v-2.5h6v-6h2.5v6h6Z' />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}